import { render, staticRenderFns } from "./ATextInput.vue?vue&type=template&id=6d1b0a50&scoped=true&"
import script from "./ATextInput.vue?vue&type=script&lang=ts&"
export * from "./ATextInput.vue?vue&type=script&lang=ts&"
import style0 from "./ATextInput.vue?vue&type=style&index=0&id=6d1b0a50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1b0a50",
  null
  
)

export default component.exports